import React from 'react';
import { Outlet } from 'react-router-dom';



export type SuperAdminLayoutProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const SuperAdminLayout = (props: SuperAdminLayoutProps) => {

  return (
    <Outlet />
  );
};
